import React, { useMemo } from 'react';

import BreadcrumbExpand from '../components/BreadcrumbsExpand';

const useChildrenRenderer = ({
  children,
  itemsToShowAfterCollapse,
  itemsToShowBeforeCollapse,
}: {
  children: React.ReactNode;
  itemsToShowAfterCollapse: number;
  itemsToShowBeforeCollapse: number;
}) => {
  const toRender = useMemo(() => {
    let childrenToRender = children;
    if (children && Array.isArray(children) && children.length > 3) {
      childrenToRender = [
        ...children.slice(0, itemsToShowBeforeCollapse),
        <BreadcrumbExpand
          children={(children as React.ReactNode[]).slice(
            itemsToShowBeforeCollapse,
            children.length - itemsToShowAfterCollapse,
          )}
          key="ellipsis"
          aria-label={'expandText'}
        />,
        ...children.slice(children.length - itemsToShowAfterCollapse, children.length),
      ];
    }
    return childrenToRender;
  }, [children, itemsToShowBeforeCollapse, itemsToShowAfterCollapse]);

  return toRender;
};

export default useChildrenRenderer;
